/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function innerSetEq(as, bs) {
    if (as.size !== bs.size) {
        return false;
    }
    for (const a of as) {
        if (!bs.has(a)) {
            return false;
        }
    }
    return true;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function setEq(as, bs) {
    switch (arguments.length) {
        case 0:
            return setEq;
        case 1:
            return (correctBs) => innerSetEq(as, correctBs);
        default:
            return innerSetEq(as, bs);
    }
}
// Get all items that are either in set A or in set B, but not in both.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function setXor(A, B) {
    const res = new Set();
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    const maybeAdd = (el) => {
        const hasA = A.has(el);
        const hasB = B.has(el);
        if (hasA !== hasB) {
            res.add(el);
        }
    };
    A.forEach(maybeAdd);
    B.forEach(maybeAdd);
    return res;
}
// Get all items that are in of set A, removing any from a that are in B also.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function setDifference(A, B) {
    const res = new Set();
    A.forEach(el => {
        if (!B.has(el)) {
            res.add(el);
        }
    });
    return res;
}
